import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTabletKeyholeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.569 4.604h-10c-.92 0-1.667.746-1.667 1.667v10c0 .92.747 1.666 1.667 1.666h10c.92 0 1.667-.746 1.667-1.666v-10c0-.92-.747-1.667-1.667-1.667M13.902 2.938V6.27M7.238 2.938V6.27M3.902 9.604h13.334"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.179}
      d="M9.738 12.938h.834"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.57 12.938v2.5"
    />
  </svg>
);
export default SvgTabletKeyholeIcon;
